import dynamic from 'next/dynamic';
import { FlyoutDrawerProps } from './FlyoutDrawer.types';

export const FlyoutDrawer = dynamic<FlyoutDrawerProps>(() =>
  import('./FlyoutDrawer').then(module => module.FlyoutDrawer)
);
